export interface Status {
  valor: StatusValue; 
  selecionado: boolean;
  descricao: string;
}

export enum StatusValue {
  PENDENTE_COMPROVACAO = 'PENDENTE_COMPROVACAO',
  COMPROVACAO_ENVIADA = 'COMPROVACAO_ENVIADA',
  EM_ANALISE = 'EM_ANALISE',
  AGUARDANDO_COMPLEMENTACAO_INFORMACOES = 'AGUARDANDO_COMPLEMENTACAO_INFORMACOES',
  PARAMETRO_ATESTADO = 'PARAMETRO_ATESTADO',
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO'
}